<!--
 * @Author: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @Date: 2023-11-27 11:09:33
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-06-12 09:44:43
 * @FilePath: /front-vps-admin/src/pages/admin/dictionary/classcode_edit.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <el-dialog :title="title && title? title : '编辑'" :visible.sync="instance.visible" :close-on-click-modal="false" :append-to-body="true">
            <yushu-datadic-form ref="form" :module="datadic" :cols="2" :show-button="false" :id="formData.id" :saveCallback="afterSave" :formData="formData" />

            <div slot="footer" class="dialog-footer">
                <el-button @click="instance.visible = false">取 消</el-button>
                <el-button type="primary" @click.native.prevent="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "CustomerPowerEditDialog",
    data() {
        return {
            instance: {
                visible: false
            },
            formData: {
            }
        };
    },
    mounted() {
        this.isNew = this.row && this.row.id ? false : true;
        if (this.row)
            this.formData = JSON.parse(JSON.stringify(this.row));
    },
    methods: {
        // 打开对话框
        open() {
            this.instance.visible = true;
        },
        close() {
            this.instance.visible = false;
        },
        handleSave() {
            this.$refs.form.onClickSave();
        },
        afterSave(data) {
            this.instance.visible = false;
            if (this.callback) {
                this.callback(data, this.isNew);
            }
        }
    }
};
</script>
